type RecordLike = Record<string, unknown>;

const VALID_ENGAGE_VALUES = ['left', 'right', 'none'] as const;

export type EngageValue = (typeof VALID_ENGAGE_VALUES)[number];

export function isEngageKey(key: unknown): boolean {
    return String(key).split('.').pop()?.toLowerCase() === 'engage';
}

export function normalizeEngage(v: unknown): EngageValue {
    const normalized = String(v ?? '')
        .toLowerCase()
        .trim();

    return VALID_ENGAGE_VALUES.includes(normalized as EngageValue)
        ? (normalized as EngageValue)
        : 'none';
}

export function getAllowedEngageFromProps(p: RecordLike = {}): EngageValue[] {
    const raw = p.EngageAllowed || p.AllowedEngage || p.EngageOptions;
    const toNorm = (x: unknown) =>
        String(x || '')
            .toLowerCase()
            .trim();
    const uniq = (arr: string[]) => Array.from(new Set(arr));

    if (!Array.isArray(raw)) return [...VALID_ENGAGE_VALUES];

    const out = uniq(raw.map(toNorm)).filter((value): value is EngageValue =>
        VALID_ENGAGE_VALUES.includes(value as EngageValue)
    );

    return out.length ? out : [...VALID_ENGAGE_VALUES];
}
